export default __webpack_public_path__ + "static/media/Picture1.2773b8f6.png";